import React from 'react';
import './HomePage.css';
import Banner from '../components/Banner';
// @ts-ignore
import Carousel from '../components/Carousel';
import ServiceAreaChecker from '../components/ServiceAreaChecker';
import ComparisonCards from '../components/ComparisonCards';
import CategoryCards from '../components/CategoryCards';
import VideoSection from '../components/VideoSection'; 
import Footer from '../components/Footer'; // Import the new Footer component

// Import images
import thermalImage from '../assets/images/ThermalME.JPEG.jpg';
import nightVisionImage from '../assets/images/White Phosphor Stars.jpg';
import rh25v2Image from '../assets/images/RH25V2_Angle2_PicRiser_CapOpen__18591-removebg-preview.png';

const HomePage = () => {
    const carouselSlides = [
        {
            title: "Meet the iRay RH25v2",
            subtitle: "Your Edge in the Dark.",
            description: "Engineered for versatility, precision, and unmatched clarity, the RH25v2 is more than just a thermal monocular—it's your ultimate force multiplier. Whether handheld, rifle-mounted, or helmet-attached, this compact powerhouse delivers crystal-clear thermal imagery in the harshest conditions.",
            buttonText: "Learn More",
            image: rh25v2Image
        },
        {
            title: "Night Vision Rentals",
            subtitle: "An Ultra-Clear Advantage",
            description: "Access high-end night vision equipment without the hefty investment. Our rental program gives you access to the latest technology for your hunting, tactical operations, or outdoor adventures.",
            buttonText: "Browse Options",
            image: nightVisionImage
        },
        {
            title: "Thermal Solutions",
            subtitle: "See What Others Can't",
            description: "Detect heat signatures day or night with our premium thermal devices. Perfect for wildlife observation, security monitoring, or tactical operations in any environment.",
            buttonText: "Explore Devices",
            image: thermalImage
        }
    ];

    return (
        <div className="capabilities-homepage">
            <Banner />
            <Carousel slides={carouselSlides} />
            <ServiceAreaChecker /> 
            <ComparisonCards />
            <CategoryCards />
            <VideoSection />
        
            
            <Footer /> {/* Add the Footer component here */}
        </div>
    );
};

export default HomePage;